import { Link } from "react-router-dom";
import { Instagram, Palette } from "lucide-react";

const TikTok = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82c-.9-.6-1.5-1.53-1.72-2.58-.05-.24-.08-.49-.08-.74h-2.9v11.9c0 1.38-1.12 2.5-2.5 2.5a2.5 2.5 0 0 1 0-5c.26 0 .51.04.75.11v-2.96a5.46 5.46 0 0 0-.75-.05 5.46 5.46 0 1 0 5.46 5.46V8.9a7.3 7.3 0 0 0 4.24 1.36V7.36c-.98 0-1.9-.31-2.5-.75z" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="relative z-[2] border-t border-border mt-20">
      <div className="max-w-6xl mx-auto px-5 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="grid place-items-center w-8 h-8 rounded-full bg-primary text-primary-foreground">
            <Palette size={16} />
          </span>
          <span className="font-display text-lg tracking-tight">Solace</span>
        </Link>

        <p className="text-sm text-muted-foreground order-3 sm:order-2">Art with feeling · A safe space for artists</p>

        <div className="flex items-center gap-3 order-2 sm:order-3">
          <a
            href="https://instagram.com/solace.app.art"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            aria-label="Instagram @solace.app.art"
            title="@solace.app.art"
            className="grid place-items-center w-10 h-10 rounded-full border border-border text-foreground/70 hover:text-primary hover:border-primary/50 transition-colors"
          >
            <Instagram size={18} />
          </a>
          <a
            href="https://tiktok.com/@solaceapp.art"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-tiktok"
            aria-label="TikTok @solaceapp.art"
            title="@solaceapp.art"
            className="grid place-items-center w-10 h-10 rounded-full border border-border text-foreground/70 hover:text-primary hover:border-primary/50 transition-colors"
          >
            <TikTok size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
}
